/* eslint react/no-array-index-key: 0 */

// react
import React from "react";
import PropTypes from "prop-types";

// styles
import css from "../Table.styl";

const TableLoading = (props) => {
	const { rows, cols } = props;

	return (
		<div className={css.tableLoader}>
			{Array.from({ length: rows }).map((d, ii) => {
				const colArray = Array.from({ length: cols });
				const gridTemplateColumns = colArray.map(() => "1fr").join(" ");

				return (
					<div key={ii} className={css.loadingRow} style={{ gridTemplateColumns }}>
						{colArray.map((dd, jj) => (
							<div key={jj} className={css.loadingCell} />
						))}
					</div>
				);
			})}
		</div>
	);
};

TableLoading.propTypes = {
	rows: PropTypes.number,
	cols: PropTypes.number,
};

TableLoading.defaultProps = {
	cols: 5,
	rows: 10,
};

export default TableLoading;
